<template>
  <div class="login">
    <modal
      name="register-modal"
      width="384"
      @before-open="openModal"
      classes="loginModel"
    >
      <div class="loginContent">
        <img
          src="~@/assets/img/login/icon-colse.png"
          class="close"
          @click="close"
        />
        <div class="loginContent" v-show="!isRegister">
          <h2 class="title">欢迎注册上船吧账号</h2>
          <v-form ref="form" @submit.native.prevent="submit">

            <div class="login_tips">此账号、密码将用于后期登录平台，请牢记</div>
            <!-- 兼容chrome -->
            <input type="password" hidden  autocomplete="new-password">
            <v-form-item
              class="form-item"
              name="login_name"
              tag="div"
              rules="required|alpha_num|min:6|max:20"
              :custom-messages="{
                required: '请输入账号',
                alpha_num: '账号只能包含字母数字字符',
                min: '账号最小为6位',
                max: '账号最大为20位'
              }"
            >
              <input
                v-model="formData.login_name"
                type="text"
                autocomplete="off"
                placeholder="输入账号（6-20位数字和字母组合）"
              />
            </v-form-item>

            <v-form-item
              class="form-item"
              name="password"
              tag="div"
              rules="required|alpha_dash|min:6|max:18"
              :custom-messages="{
                required: '请输入密码',
                alpha_dash: '密码只能包含字母数字字符',
                min: '密码最小为6位',
                max: '密码最大为18位'
              }"
            >
              <input
                v-model="formData.password"
                type="password"
                autocomplete="off"
                placeholder="设置登录密码"
              />
            </v-form-item>
            <v-form-item
              class="form-item"
              name="mobile"
              tag="div"
              rules="required|mobile"
              :custom-messages="{
                required: '请输入手机号码',
                mobile: '请输入正确的手机号码'
              }"
            >
              <input
                v-model="formData.mobile"
                type="text"
                maxlength="11"
                placeholder="输入手机号"
              />
            </v-form-item>
            <div class="zuhe">
              <v-form-item
                class="form-item Code"
                name="verifyCode"
                tag="div"
                ref="verifyCode"
                rules="required|numeric|min:0|max:2"
                :custom-messages="{
                  required: '请输入正确的结果',
                  numeric: '只能输入数字',
                  min: '图形验证码最小为1位',
                  max: '图形验证码最大为2位'
                }"
              >
                <input
                  v-model="formData.verifyCode"
                  type="text"
                  placeholder="输入计算的结果"
                />
              </v-form-item>
              <img
                :src="captchaUrl"
                alt="图形验证码"
                class="captchaCode"
                @click="RefreshCode"
              />
            </div>
            <div class="zuhe">
              <v-form-item
                class="form-item Code"
                name="code"
                tag="div"
                ref="code"
                rules="required|alpha_num|min:1|max:4"
                :custom-messages="{
                  required: '请输入短信验证码',
                  alpha_num: '请输入正确的短信验证码',
                  min: '短信验证码最小为1位',
                  max: '短信验证码最大为4位'
                }"
              >
                <input
                  v-model="formData.code"
                  type="text"
                  placeholder="短信验证码"
                />
              </v-form-item>
              <v-btn
                type="default"
                class="VerificationCode"
                v-show="!showVerCode"
                @click="getVerificationCode"
                >获取验证码</v-btn
              >
              <v-btn
                type="default"
                class="VerificationCode grey"
                v-show="showVerCode"
                >{{ verificationText }}</v-btn
              >
            </div>
            <div class="opationBtn">
              <v-btn type="primary" nativeType="submit">注册</v-btn>
            </div>
          </v-form>
        </div>

        <div class="loginContent register-success" v-show="isRegister">
          <img src="~@/assets/img/login/icon-success.png" class="successImg" />
          <h3>账号注册成功</h3>
          <div class="opationBtn">
            <v-btn type="primary" @click="gotoPage">完善入驻信息</v-btn>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import VBtn from "../VBtn/VBtn.vue";
import { VForm, VFormItem } from "../VForm/index";
import { getUserSendCode } from "@/services/login";
export default {
  name: "register",
  data() {
    return {
      formData: {
        mobile: "", //手机号
        verifyCode: "", //图形验证码
        captcha: "", //图形验证码
        code: "", //短信验证码
        login_name: "", //用户名
        password: "", //密码
        type: "register"
      },
      verificationText: "获取验证码",
      verificationVal: 60,
      activeIndex: 1, //默认选中密码登录
      Timer: null, //
      showVerCode: false, //是否倒计时
      captchaUrl: "/api/user/captcha",
      isRegister: false //是否注册成功
    };
  },
  methods: {
    //切换登录方式
    switchTab(value) {
      this.activeIndex = value;
    },
    async submit() {
      let formRef = this.$refs.form.getForm();
      const isValid = await formRef.validate();
      if (!isValid) {
        // 没有通过校验
        return false;
      }
      this.$store
        .dispatch("user/register", this.formData)
        .then(res => {
          // if (res.code && res.code == 10000) {
          if (res.code && (res.code == 10000 || res.code == 10001)) {
            this.isRegister = true;
          } else {
            this.$message({
              type: "error",
              text: res.msg
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "error",
            text: error
          });
        });
    },
    //关闭弹框
    close() {
      this.$modal.hide("register-modal");
      if (this.isRegister === true) {
        window.location.reload();
      }
    },
    //图形验证码
    RefreshCode() {
      let tempUrl = this.captchaUrl.split("?");
      this.captchaUrl = tempUrl[0] + "?time=" + new Date().getTime();
      this.formData.verifyCode = "";
      this.formData.code = "";
    },
    //获取短信验证码
    getVerificationCode() {
      if (this.formData.mobile != "") {
        this.getUserSendCode(); //获取验证码
      } else {
        this.$refs.code.validate();
        this.$refs.verifyCode.validate();
      }
    },
    //获取短信验证码
    async getUserSendCode() {
      const that = this;
      this.formData.captcha = this.formData.verifyCode; //图形验证码
      let { data, code, msg } = await getUserSendCode(this.formData);
      if (code === 10000 || code === 200) {
        that.showVerCode = true;
        that.Timer = setInterval(() => {
          that.verificationText = `重新发送(${that.verificationVal})`;
          that.verificationVal--;
          if (that.verificationVal <= 0) {
            that.showVerCode = false;
            clearInterval(that.Timer);
            that.verificationVal = 60;
            that.verificationText = `重新发送(60)`;
          }
        }, 1000);
        console.log(data);
      } else {
        this.RefreshCode();
        this.$message({
          type: "error",
          text: msg
        });
        console.log(msg);
      }
    },
    //跳转到分销入住页面
    gotoPage() {
      window.location.href = "/settled/process";
    },
    openModal() {
      this.showVerCode = false;
      this.formData.mobile = "";
      this.formData.verifyCode = "";
      this.formData.captcha = "";
      this.formData.code = "";
      this.formData.login_name = "";
      this.formData.password = "";
    }
  },
  components: { VBtn, VForm, VFormItem }
};
</script>
<style lang="scss" scoped>

// @import "~@/assets/scss/base/public.scss";
::v-deep .loginModel {
  height: auto !important;
  background: $color-white;
  border-radius: 2px;
  padding: 35px 40px;
  box-sizing: border-box;
  .loginContent {
    position: relative;
    &.register-success {
      padding: 60px 0;
    }
    .title {
      width: 100%;
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: $color-grey-1;
      line-height: 30px;
      text-align: center;
      cursor: default;
    }
    .close {
      position: absolute;
      right: -50px;
      top: -45px;
      width: 27px;
    }
    .switchTab {
      width: 100%;
      height: auto;
      overflow: hidden;
      span {
        height: 28px;
        font-size: 20px;
        font-weight: 500;
        color: #9999ad;
        line-height: 28px;
        cursor: pointer;
        display: inline-block;
      }
      span.active {
        font-size: 24px;
        font-weight: 500;
        color: $color-grey-1;
        line-height: 33px;
      }
      span:last-child {
        margin-left: 20px;
      }
    }
    .formData {
      margin-top: 6px;
      .form-item {
        height: auto;
        input {
          width: 100%;
          height: 40px;
          line-height: 40px;
          padding-left: 10px;
          box-sizing: border-box;
          border-radius: 2px;
          border: 1px solid $color-grey-7;
          font-size: 14px;
        }
        input:focus {
          border-color: $color-orange;
        }
        .error {
          margin-top: 5px;
          color: $color-orange;
          font-size: 12px;
        }
      }

      .login_tips {
        color: $color-grey-9;
        font-size: 14px;
        font-weight: 400;
        // margin-top: 5px;
        margin-bottom: 20px;
        text-align: center;
        cursor: default;
      }
    }
    .zuhe {
      font-size: 0;
      .Code,
      .captchaCode {
        display: inline-block;
        vertical-align: top;
      }
      .Code {
        width: 190px;
      }
      .captchaCode,
      .VerificationCode {
        width: 100px;
        height: 38px;
        border: 1px solid $color-grey-7;
        margin-left: 12px;
        cursor: pointer;
      }
      .VerificationCode {
        padding: 0;
        color: $color-orange;
        border: 1px solid $color-orange;
        &.grey {
          border-color: $color-grey-7;
          color: $color-grey-9;
        }
        .v-btn__content {
          width: 100%;
          height: 100%;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .opationBtn {
      .v-btn--primary {
        width: 100%;
        background: $color-orange;
        color: $color-white;
        font-size: 16px;
        font-weight: 500;
        border-radius: 2px;
      }
    }
    .successImg {
      display: block;
      margin: 0 auto;
    }
    h3 {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: $color-grey-1;
      line-height: 30px;
      text-align: center;
      margin-bottom: 80px;
    }
  }
}

</style>
